import { AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import Cropper from "cropperjs";
import { Router } from '@angular/router';
import { combineLatest, finalize, mergeMap, of, Subject, switchMap } from 'rxjs';

import { PhotoService } from '../photo/photo.service';
import { AuthService } from '../auth.service';
import { LayoutService } from '../layout.service';
import { LoaderService } from '../loader.service';

import { User } from '../shared/interfaces/user';
import { Photo } from '../shared/interfaces/photo';
import { LoaderComponent } from '../shared/loader/loader.component';

@Component({
  selector: 'app-profile-crop',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  templateUrl: './profile-crop.component.html',
  styleUrl: './profile-crop.component.scss'
})
export class ProfileCropComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren('contextualMenuClosed') contextualMenusClosed!: QueryList<ElementRef>
  @ViewChildren('contextualMenuOpened') contextualMenusOpened!: QueryList<ElementRef>
  @ViewChild("image", { static: false }) imageElement!: ElementRef

  @Output() fileList: EventEmitter<boolean> = new EventEmitter()
  
  loading$ = this.loaderService.loading$
  user!: User
  photos: (Photo | null)[] = []
  tempCropperPhotoInBase64!: string
  showCropper!: { 
    data: File,
    temp?: string,
    size: { height: number; width: number; }
  } | null
  croppedImage: string = ''
  cropData!: { x: number; y: number; height: number; width: number; preview?: string; }
  uploadedPhotoSrc = ''
  isDesktop = this.layoutService.isDesktop
  origin = ''
  private readonly _destroyed = new Subject<void>()
  imageDestination!: string
  private cropper!: Cropper | null
  cropDetails!: Cropper.Data

  constructor(
    private location: Location,
    private photoService: PhotoService,
    private authService: AuthService,
    private layoutService: LayoutService,
    private loaderService: LoaderService,
    public router: Router
  ){}

  ngOnInit(){
    console.log('ngOnInit profile-crop')
    if(this.photoService.photoToCropInBase64) this.uploadedPhotoSrc = this.photoService.photoToCropInBase64
    if(this.router.url.includes('upload') || this.router.url.includes('subscribe')){
      this.origin = 'upload'
    }

    this.showCropper = this.photoService.showCropper

    const userStoredLocally = this.authService.get('user')
    if(userStoredLocally) this.user = JSON.parse(this.authService.get('user'))
  }

  ngAfterViewInit() {
    console.log('photo-crop')
    this.cropper = new Cropper(this.imageElement.nativeElement, {
      zoomable: false,
      scalable: false,
      aspectRatio: 1,
      crop: (event) => {         
        if(!this.cropper) return
        this.imageDestination = this.cropper.getCroppedCanvas().toDataURL("image/jpeg")
        this.cropDetails = event.detail

        this.cropData = {
          height: Math.floor(this.cropDetails.height), 
          width: Math.floor(this.cropDetails.width), 
          x: Math.floor(this.cropDetails.x), 
          y: Math.floor(this.cropDetails.y)
        }
      }
    })
  }

  saveCropData() {
    console.log('saveCropData de profile-crop')
    const tempCropperPhotoInBase64Arr = this.uploadedPhotoSrc.split(',')

    //if(!this.showCropper?.temp){ throw new Error('Source image is missing') }

    this.loaderService.show()

    // step 2: sent base64 photo
   
    // crop image on front
    const img = new Image()
    img.src = this.uploadedPhotoSrc
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    const data: {
      origin: string, //destination image in base64
      mime: string
    } = {
      origin: tempCropperPhotoInBase64Arr[1],
      mime: tempCropperPhotoInBase64Arr[1][0] === 'i' ? 'png' : 'jpeg'
    }
    
    if(img && ctx){
      img.onload = () => {
        ctx.drawImage(img,this.cropData.x,this.cropData.y,this.cropData.width,this.cropData.height,0,0,50,50)
      }
    }
    // crop image on front

    // store image on S3 bucket and crop
    this.photoService.saveOriginalPhoto(data, 'profile').pipe(
      mergeMap((res: { photo: { id: number, signed_url: string, url: string }}) => {
        this.loaderService.show()
        return combineLatest([of(res), this.photoService.sendPhotoToSignedUrl(res.photo.signed_url, this.photoService.photoFile!, data.mime)]).pipe(
          switchMap(([res,]) => {
            return this.photoService.cropPhoto(this.cropData, res.photo.id)//data.origin, croppedImageArr[1],
          }),
          finalize(() => {
            this.loaderService.hide()
          })
      )})
    ).subscribe(() => {   
      if(this.router.url.includes('my-profile')){
        this.authService.getProfile(this.user.id).subscribe(async(res) => {
          this.user = res
          this.photos = []

          for (let i = 0; i < 6; i++) {
            if(!res.photos?.[i]){
              this.photos.push(null)
            } else {
              this.photos.push(res.photos[i])
            }
          }

          this.authService.setAuthMe(this.user)
        })

        this.cropper = null
        this.location.back()
      } else {
        this.cropper = null
        this.router.navigate(['/photo'])
      }
    })

    // A SUPPRIMER
    /* this.photoService.saveOriginalPhoto(data).subscribe(async(res) => {
      console.log(res)
      if(res.photo.id){
        // step 3: crop the photo
        const croppedImageArr = this.croppedImage.split(',')
        const photoId = res.photo.id

        this.photoService.cropPhoto(data.origin, croppedImageArr[1], this.cropData, photoId).subscribe(res => {
          if(!res) return
         
          this.loaderService.hide()

          // only on My Profile
          if(this.router.url.includes('my-profile')){
            this.authService.getProfile(this.user.id).subscribe(async(res) => {
              this.user = res
              this.photos = []
  
              for (let i = 0; i < 6; i++) {
                if(!res.photos?.[i]){
                  this.photos.push(null)
                } else {
                  this.photos.push(res.photos[i])
                }
              }
  
              this.authService.setAuthMe(this.user)
            })

            this.cropper = null
            this.location.back()
          } else {
            this.cropper = null
            this.router.navigate(['/photo'])
          }
        })
      }
    }) */
  }
 
  discardPhoto(){
    this.fileList.emit(false)
    this.location.back()
  }

  // only for upload-photo
  discardUploadedPhoto(){
    this.photoService.fileList.next(null)
    this.router.navigate(['/upload-photo'])
  }

  ngOnDestroy(){
    console.log('onDestroy')
    this._destroyed.next()
    this._destroyed.complete()
  }
}
